export class Email {
    toEmail: string;
    subject: string;
    body: string;
}